import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
  expiresAt: string | Date; // Can be a Date object or a string that can be parsed as a Date.
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    // Convert expiresAt to a timestamp if it's not already one
    const expiryTime = new Date(expiresAt).getTime();

    const updateTimer = () => {
      const now = Date.now();
      const diff = expiryTime - now;
      setTimeLeft(diff > 0 ? diff : 0);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  // Convert timeLeft (in ms) to days, hours, minutes, seconds
  const seconds = Math.floor((timeLeft / 1000) % 60);
  const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

  return (
    <div className="countdown-timer">
      {timeLeft > 0 ? (
        <span>
          {days > 0 && `${days}d `}
          {hours > 0 && `${hours}h `}
          {minutes}m {seconds}s
        </span>
      ) : (
        <span>Expired</span>
      )}
    </div>
  );
};

export default CountdownTimer;
